import React from "react";
import classNames from "classnames";
import {useTranslation} from "react-i18next";
import {CLabel, CSelect} from "@coreui/react";
import "./ItemsPerPageSelector.scss";

const ItemsPerPageSelector = (props) => {
  const {t} = useTranslation();
  const {className, onChange, options, disabled, value} = props;

  return (
    <div className={classNames("ItemsPerPageSelector", className)}>
      <CLabel className="ItemsPerPageSelector__label">
        {t("table:itemsAmount", "items per page:")}
      </CLabel>
      <CSelect
        custom
        id="itemsPerPage"
        name="itemsPerPage"
        className="ItemsPerPageSelector__select"
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        value={value}
      >
        {options.map((option) => <option key={option} value={option}>{option}</option>)}
      </CSelect>
    </div>
  );
};

export default ItemsPerPageSelector;
